import React, { useEffect, useState, useCallback } from "react";
//import EventData from '../../Data/Admin/EventTabledata.json';
import { Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faFileExcel} from '@fortawesome/free-solid-svg-icons';
import { getAdminEvents } from '../../Service';
import { deleteEvent } from '../../Service';
import Swal from "sweetalert2";
import ReactPaginate from 'react-paginate';
import PaginatedItems from './Pagination';
import axios from 'axios';
import ClipLoader from "react-spinners/ClipLoader";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "#96D2CE",
};

export default function EventList(){

    const [EventData, setEventData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [color, setColor] = useState("#ffffff");
    const [perPage, setPerPage] = useState(100);
    const [curPage, setCurPage] = useState(1);
    const [totalRec, setTotalRec] = useState(0);

    /** ------------------------ Pagination States -------------- */
    const data = EventData;
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [itemsPerPage, setitemsPerPage] = useState(0);
 /** ------------------------ Pagination States -------------- */

 console.log(process.env.REACT_APP_EVNTPRICE);
    useEffect(() => {
        let params = { 'perPage': perPage, 'curPage': curPage, 'admin_list': 1 };
        getAdminEvents(params).then(res => handleResponse(res))
      }, [curPage]);


      const handleResponse = (response) => {
        console.log(response);
        if(response.data.code==400){ //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
          }else if(response.data.code==200){  //IF Request is Success
            setEventData(response.data.data.event.items);
            setTotalRec(response.data.data.event.total);
            setitemsPerPage(10); //SET LIST OF RECORDS PER PAGE.
            setLoading(false);
          }
      }

/** ------------------------ Pagination Start Here ------------------------  */
      useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));

      }, [itemOffset, itemsPerPage]);

      
      const handlePageClick = useCallback ((event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        setItemOffset(newOffset);
        console.log(newOffset);
      });
  /** ------------------------ Pagination Ends Here ------------------------  */
  
      const doDelete = (event_id)=> {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want delete this event?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
                let params = { 'id': event_id };
                deleteEvent(params).then(res => handleDeleteRes(res, event_id))
            }
          })
        
    }
  
    const handleDeleteRes = (response, event_id) => {
        console.log(response);
        if(response.data.code==400){ //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
          }else if(response.data.code==200){  //IF Request is Success
            let allEventData = currentItems;
            let filteredArray =  allEventData.filter(item => item.id !== event_id);
            setCurrentItems(filteredArray);
            setTotalRec(totalRec-1);
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Event Deleted Successfully',
                showConfirmButton: false,
                timer: 1500
              })
          }
      }

      return (
        <>
        <section className="admin-section">
        <div className="container">
        <div className="row">
        <div className="col-12">
          <div className="card admin-table">
          { 
    loading ?
    <ClipLoader color={color} loading={loading} cssOverride={override} size={250} />
    :
    <>
            <div className="card-header">
            <h1>({totalRec}) EVENTS</h1>
            <Link to="/AddEventdetails" className="add-event">+ Add Event</Link>     
            </div>
            <div className="card-body">
                <div className="table-responsive">
            <table className="table">
            <thead>
                <tr>
                    <th>Event</th>
                    <th>Applicants</th>
                    <th>Export</th>
                    <th>Event Dates</th>
                    <th> </th>
                </tr>
            </thead>
            <tbody>
            {
                
                currentItems.map( data => (
                <tr key={data.id}>
                    <td>
                    {data.event_name} <br/>
                    {(() => {
                        if(data.event_type==1){
                            return (
                                <>(Physical Event)</>
                            )
                        }else{
                            return (
                                <>(Virtual Event)</>
                            )
                        }
                    })()}
                    <br/>
                    <Link to={ `/editeventdetails/${data.id}` }>Edit Details</Link><br/>
                    <Link to="#">Upload Booths Map</Link><br/>
                    <Link to={"/programminglist/"+data.id}>Fair Programming</Link>
                    </td>            
                    <td><Link to={ `/view_application/${data.id}` } >View Applicants</Link></td>
                    <td>
                    <tbody className="ship">
                    <tr>
                    <td>
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Applicants</Link><br />
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Shipping / Load In</Link><br />
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Catalog Listing</Link><br />
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Social Media Content</Link><br />
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Programming</Link> 
                    </td>
                    <td>
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Guest List</Link><br />
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Badges</Link><br />
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Booth Extras</Link><br />
                    <Link to="#"><FontAwesomeIcon className="excel" icon={faFileExcel} /> Catalogue Images</Link><br />
                    </td>
                </tr>
            </tbody>
        </td>
        <td>
        <p><span>Start Date</span>: {data.start_date}</p>
        <p><span>End Date</span>: {data.end_date}</p>
        </td>
        <td className="table-close">
        <Link to="#"><FontAwesomeIcon icon={faXmark} onClick={()=> doDelete(data.id)} /></Link>
        </td>
        </tr> 
        
        ))
        }
        </tbody>
        </table> 
        
        
        </div>
            </div>
            <div className="card-footer">
              <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="Previous"
                    renderOnZeroPageCount={null}
                    className="admin-paginate"
              />
            </div>
            </>
}
        </div>
        </div>
        </div>
        </div>  
        </section>
                
              </>
            );
}
